import { api } from "../../lib/api";

export const STATUSES = {
  waiting_return: { label: "En attente retour", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  in_progress: { label: "En cours", cls: "bg-sky-50 text-sky-800 border-sky-200" },
  done: { label: "Terminé", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
};
export const OUTCOMES = { exchanged: "Échangé", refunded: "Remboursé" };

export const CARRIERS = {
  Colissimo: (n) => `https://www.laposte.fr/outils/suivre-vos-envois?code=${n}`,
  Chronopost: (n) => `https://www.chronopost.fr/tracking-no-cms/suivi-page?listeNumerosLT=${n}`,
  UPS: (n) => `https://www.ups.com/track?tracknum=${n}`,
  DHL: (n) => `https://www.dhl.com/fr-fr/home/suivi.html?tracking-id=${n}`,
  DPD: (n) => `https://trace.dpd.fr/fr/trace/${n}`,
  GLS: (n) => `https://gls-group.com/FR/fr/suivi-colis?match=${n}`,
  FedEx: (n) => `https://www.fedex.com/fedextrack/?trknbr=${n}`,
  TNT: (n) => `https://www.tnt.com/express/fr_fr/site/outils-expedition/suivi.html?searchType=con&cons=${n}`,
};

export const trackingUrl = (carrier, n) => (n && CARRIERS[carrier] ? CARRIERS[carrier](encodeURIComponent(n)) : null);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(" — ");
  return typeof d === "string" ? d : e?.message || "Erreur";
};

export function StatusBadge({ status }) {
  const s = STATUSES[status] || STATUSES.waiting_return;
  return <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium ${s.cls}`} data-testid={`sav-status-${status}`}>{s.label}</span>;
}

export const fmtDay = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-FR") : "—");
export const daysSince = (iso) => (iso ? Math.floor((Date.now() - new Date(iso).getTime()) / 86400000) : 0);

export async function downloadBlob(url, filename) {
  const r = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = href; a.download = filename; a.click();
  setTimeout(() => URL.revokeObjectURL(href), 2000);
}

export const webUrl = (u) => (!u ? null : /^https?:\/\//i.test(u) ? u : `https://${u}`);
